import React from "react";

import DesktopSidebar from "./DesktopSidebar";
import MobileAppBar from "./MobileAppBar";
import useIsMobile from "src/hooks/useIsMobile";

const Navigation = () => (useIsMobile() ? <MobileAppBar /> : <DesktopSidebar />);

export default Navigation;
